import {useAppSelector} from '../../store/store';
import {__} from '../../support/lang/translations';
import {SimpleSelect, SimpleSelectOption} from '../select/simple_select.tsx';

interface OwnProps {
    isLoading: boolean;
    isLocked: boolean;
}

export function DefaultLocationSelect(props: OwnProps) {
    const locations = useAppSelector((state) => state.appConfig.locations);
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);
    const defaultLocationId = meData?.default_location_id;
    const locationOptions: SimpleSelectOption[] =
        locations
            ?.filter((loc): loc is NonNullable<typeof loc> => loc != null)
            .map((location) => {
                return {
                    label: location.name || '',
                    value: location.id || '',
                };
            }) || [];

    return (
        <label>
            {__('profile.fields.default_location')}
            <SimpleSelect
                name="default_location"
                defaultValue={defaultLocationId}
                options={locationOptions}
                emptyLabel={
                    __('general.select_value', {
                        name: __('profile.fields.select.default_location') as string,
                    }) as string
                }
                isDisabled={props.isLoading}
                isLocked={props.isLocked}
                useHiddenInput={true}
            />
        </label>
    );
}
